import { createSelector } from 'reselect'
import { RootStoreState } from '@src/models/app.types'
import { startOfCurrentWeek } from '../utils'

export const actionGoalsStateSelector = (state: RootStoreState) => state.actionGoals

export const currentWeekSummariesSelector = createSelector(
  actionGoalsStateSelector,
  (actionGoalsStore) => {
    const { summariesByWeek } = actionGoalsStore
    const currentWeekStart = startOfCurrentWeek()

    return summariesByWeek[currentWeekStart] || []
  },
)

export const isSummaryForWeekCachedSelector = (startOfWeek: string) =>
  createSelector(actionGoalsStateSelector, (actionGoalsStore) => {
    const { summariesByWeek } = actionGoalsStore

    return !!summariesByWeek[startOfWeek]
  })

export const summariesForWeekSelector = (startOfWeek: string) =>
  createSelector(actionGoalsStateSelector, (actionGoalsStore) => {
    const { summariesByWeek } = actionGoalsStore

    return summariesByWeek[startOfWeek] || []
  })
